"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTION_USER_OPT_OUT = exports.ACTION_USER_OPT_IN = exports.ACTION_REJECT = exports.ACTION_INIT_OPT = exports.ACTION_HUB_OPT_OUT = exports.ACTION_HUB_OPT_IN = exports.ACTION_STATE_UPDATED = exports.ACTION_CHOICE_RESET = void 0;
var ACTION_CHOICE_RESET = 'CHOICE_RESET';
exports.ACTION_CHOICE_RESET = ACTION_CHOICE_RESET;
var ACTION_STATE_UPDATED = 'CHOICE_UPDATED';
exports.ACTION_STATE_UPDATED = ACTION_STATE_UPDATED;
var ACTION_HUB_OPT_IN = 'HUB_OPT_IN';
exports.ACTION_HUB_OPT_IN = ACTION_HUB_OPT_IN;
var ACTION_HUB_OPT_OUT = 'HUB_OPT_OUT';
exports.ACTION_HUB_OPT_OUT = ACTION_HUB_OPT_OUT;
var ACTION_INIT_OPT = 'INIT_OPT';
exports.ACTION_INIT_OPT = ACTION_INIT_OPT;
var ACTION_REJECT = 'REJECT';
exports.ACTION_REJECT = ACTION_REJECT;
var ACTION_USER_OPT_IN = 'USER_OPT_IN';
exports.ACTION_USER_OPT_IN = ACTION_USER_OPT_IN;
var ACTION_USER_OPT_OUT = 'USER_OPT_OUT';
exports.ACTION_USER_OPT_OUT = ACTION_USER_OPT_OUT;